/* global G, PLATFORM */
import ACLError from 'lib/manager/acl/error'
import { isObj } from 'lib/util'

const ACL_PROPS = 'AclProps'
const PLATFORM_ACL_PROPS = PLATFORM + ACL_PROPS

export const get = obj => obj[G.ADAPTER][G.ACL]
export const active = obj => get(obj)[G.PROPS].active // true : false
export const allow = () => true
export const deny = m => { throw new ACLError(m || 'acl.check.deny') }
export const strategy = enabled => (!enabled ? deny() : allow())
export const create = (acl, props = { hidden: true }) => ({
  [G.META]: Object.keys(acl).pop(), // domain
  [G.ACL]: Object.values(acl).pop(), // acls
  [G.PROPS]: { ...props }, // aclProps
})
export const valid = acl => !isObj(acl) && deny('structure should be { domain: [acl] }')
const aclProps = obj => {
  const configuration = obj[G.CONFIGURATION]
  const { aclProps: rootProps = { hidden: true }, [PLATFORM_ACL_PROPS]: rootPlatformProps = {} } = configuration
  const { [PLATFORM]: platformProps = {}, mobile, web, ...aclProps } = rootProps || {}
  return /** @type Object */ { ...aclProps, ...platformProps, ...rootPlatformProps }
}
export const resolve = (obj) => {
  let acl = null
  try {
    valid(obj[G.ACL])
    acl = create(obj[G.ACL], aclProps(obj))
  } catch (e) {
    console.warn(`${e.name} - ${obj[G.PROPS].key} - ${e.message}`)
  }
  return acl
}

/**
 * Mocks a component so that we can use it with acl manager's `component` method,
 * which encapsulates all available acl checks.
 *
 * @param {Object} data
 * @private
 */
export const _mockACLComponent = data => ({
  [G.CHILDREN]: {
    create: {
      [G.PROPS]: { key: 'create' },
      ...data?.acl && { [G.ACL]: data?.acl },
      [G.CONFIGURATION]: {
        aclProps: { failed: true },
        ...data?.aclContext && { aclContext: data?.aclContext },
        ...data?.aclContextRole && { aclContextRole: data?.aclContextRole },
      },
    },
  },
})
